export const FAQ_ITEMS = [
    {
        question: "What is Accruewise?",
        answer:
            "Accruewise is a fintech platform that helps you save, budget, shop, and track spending through one app. It supports goal-based saving, marketplace shopping, a virtual card, wallet features, and everyday spend tracking.",
    },
    {
        question: "Is Accruewise available in India only?",
        answer:
            "Yes. Accruewise is currently available in India. The company plans to expand to additional markets in the future.",
    },
    {
        question: "How do I deposit money into Accruewise?",
        answer:
            "You can add money using UPI, debit cards, net banking, or automatic round-ups from everyday transactions.",
    },
    {
        question: "Are there any withdrawal charges on Accruewise?",
        answer:
            "No. Withdrawals are free, and you can move money back to your linked bank account at any time.",
    },
    {
        question: "Is my money safe with Accruewise?",
        answer:
            "Accruewise uses encrypted transactions and works with regulated banking partners to help keep user funds and data secure.",
    },
    {
        question: "Does Accruewise share my personal data?",
        answer:
            "Accruewise does not share your personal or financial data with third parties without your consent, except where required by law or described in the privacy policy.",
    },
];
